import { useState } from 'react';

import TabButtons from 'pages/components/tabNavigation/TabButtons';

import {
  BackMainMessage,
  BackMessage,
  BackMessage2,
  BackPermissions,
  ChatWrapper,
  TabButton1,
} from './Chat.styles';
import ByRole from './byRole';
import ByTeam from './byTeam';
import ByUser from './byUser';
import { RowIcon } from './components/rowIcon';

const Chat = () => {
  const tabs = [{ name: 'By Role' }, { name: 'By User' }, { name: 'By Team' }];

  const [activeTab, setActiveTab] = useState('By Role');

  const colors = [
    { bg: 'linear-gradient(135deg, #D0FAE5 0%, #A4F4CF 100%)', color: '#15C7A7' },
    { bg: 'linear-gradient(135deg, #F1F5F9 0%, #E2E8F0 100%)', color: '#62748E' },
    { bg: 'linear-gradient(135deg, #FEF3C6 0%, #FEE685 100%)', color: 'white' },
    { bg: 'linear-gradient(135deg, #2A76E9 0%, #20457B 100%)', color: 'white' },
  ];

  return (
    <ChatWrapper>
      <BackPermissions>
        <RowIcon size={56} color={colors[3]} />
        <BackMainMessage>
          <BackMessage>Configure permissions for unified messaging</BackMessage>
          <BackMessage2>Unified Communication access</BackMessage2>
        </BackMainMessage>
      </BackPermissions>

      <TabButton1>
        <TabButtons
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={(tabValue) => setActiveTab(tabValue)}
        />
      </TabButton1>

      {activeTab === 'By Role' && <ByRole />}
      {activeTab === 'By User' && <ByUser />}
      {activeTab === 'By Team' && <ByTeam />}
    </ChatWrapper>
  );
};

export default Chat;
